import { useEffect, useState } from 'react';
import { DashboardSection } from '@/components/Dashboard/enums/shared';
import { useLocalStorage } from '@/hooks/useLocalStorage';

const DASHBOARD_SECTION_STORAGE_KEY = 'dashboardCurrentSelection';

const DEFAULT_DASHBOARD_SECTION = DashboardSection.RecentRecipes;

const DASHBOARD_SECTIONS = new Set(Object.values(DashboardSection));

const isDashboardSection = (value: string | null): value is DashboardSection => {
  return !!value && DASHBOARD_SECTIONS.has(value as DashboardSection);
};

export const useDashboardSection = () => {
  const { getItem, setItem } = useLocalStorage<DashboardSection>(DASHBOARD_SECTION_STORAGE_KEY);

  const [currentSelection, setCurrentSelection] = useState<DashboardSection>(() => {
    const stored = getItem(false);
    return isDashboardSection(stored) ? stored : DEFAULT_DASHBOARD_SECTION;
  });

  useEffect(() => {
    setItem(currentSelection, false);
  }, [currentSelection, setItem]);

  return {
    currentSelection,
    setCurrentSelection,
  };
};
